import React from 'react';
import BillReport from '../BillReport';

export default function BillReportPage({ sessionObject }) {
  return (
    <div className="page-bilty">
    <BillReport sessionObject={sessionObject} />
    </div>
  );
}
